import React from "react";
import { Link } from "react-router-dom";
import { Camera, ArrowRight, ImageIcon } from "lucide-react";
import { mediaUrl } from "@/lib/media";
import { HomePanel, PanelEmpty } from "./HomePanel";
import { fmtDateHuman, pluralize } from "@/portal/format";

/** „Fotografii recente de pe șantier” — ultimele 3 poze + tile „+N fotografii”. */
export function PhotosCard({ photos, total, project }) {
  const list = (photos || []).slice(0, 3);
  const pid = list[0]?.project_id || project?.id;
  const galleryTo = pid ? `/portal/proiecte/${pid}?tab=galerie` : "/portal/proiecte";
  const rest = Math.max(0, (total || 0) - list.length);
  return (
    <HomePanel icon={Camera} title="Fotografii recente de pe șantier" to={galleryTo} testid="home-photos">
      {list.length === 0 ? <PanelEmpty icon={ImageIcon} text="Fotografiile de pe șantier vor apărea aici pe măsură ce sunt publicate." /> : (
        <div className={`grid gap-3 ${rest > 0 ? "grid-cols-2 sm:grid-cols-[repeat(3,minmax(0,1fr))_minmax(64px,0.55fr)]" : "grid-cols-3"}`} data-testid="home-photos-grid">
          {list.map((ph) => (
            <Link key={ph.id} to={`/portal/proiecte/${ph.project_id}?tab=galerie`} className="group min-w-0" data-testid={`home-photo-${ph.id}`}>
              <span className="block aspect-[4/3] rounded-[8px] overflow-hidden bg-cp-bg-subtle">
                <img src={mediaUrl(ph.thumbnail_url || ph.url)} alt={ph.caption || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
              </span>
              <span className="block mt-1.5 text-[12.5px] font-medium text-cp-text truncate">{ph.caption || ph.category || "Fotografie"}</span>
              <span className="block cp-meta truncate">{fmtDateHuman(ph.uploaded_at)}</span>
            </Link>
          ))}
          {rest > 0 && (
            <Link to={galleryTo} className="aspect-[4/3] sm:aspect-auto sm:h-full rounded-[8px] border border-cp-border bg-cp-bg-subtle/70 hover:bg-cp-accent-soft hover:border-cp-accent-border transition-colors flex flex-col items-center justify-center text-center px-2 min-w-0 cp-lift" data-testid="home-photos-more">
              <span className="text-[15px] font-semibold text-cp-text">+{rest}</span>
              <span className="text-[11px] text-cp-text-2 leading-tight">{pluralize(rest, "fotografie", "fotografii").replace(/^\d+\s/, "")}</span>
              <ArrowRight className="h-4 w-4 text-cp-accent mt-1.5" aria-hidden="true" />
            </Link>
          )}
        </div>
      )}
    </HomePanel>
  );
}
